import React, { useState, useEffect, useContext, Fragment } from "react";
import PageTitle from "../pageTitle";
import Logo from "../logo";
import CarChangeDropdown from "../carChangeDropdown";
import useMediaQuery from "../../hooks/useMediaQuery";
import IconButton from "../iconButton";
import TutorialModal from "../tutorialModal";
import ProfileDropdown from "../profileDropdown";
// import SettingIcon from "../../icons/settingIcon";
import QuestionIcon from "../../icons/questionIcon";
import styles from "./style.module.css";
// import { MENU_SLUG } from "../../constants/constants";
import { CarContext } from "../../contexts/carProvider";
import { useAuth } from "../../hooks/useAuth";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useUpdateCurrentCar } from "../../hooks/updateCurrentCar";

const PageHead = ({
  title,
  hideCarChange = false,
  carChangeDisabled = false,
  hideSetting = false,
  logo,
  logoLink,
  tutorialContent,
}) => {
  const { auth } = useAuth();
  const { cars } = useContext(CarContext);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [selectedCar, setSelectedCar] = useState({});
  const [openTutorialModal, setOpenTutorialModal] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const updateCurrentCar = useUpdateCurrentCar();

  const handleCarChange = async (car) => {
    try {
      let url = `/cars/set-current`;
      let options = {
        method: "PUT",
        url,
        data: {
          carId: car._id,
        },
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            updateCurrentCar(response);
            setSelectedCar(car);
            window.location.reload();
          }
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    } catch (error) {
      // console.log(error);
    }
  };

  const handleOpenTutorialModal = () => {
    setOpenTutorialModal(true);
  };

  const handleCloseTutorialModal = () => {
    setOpenTutorialModal(false);
  };

  useEffect(() => {
    if (cars.length > 0 && auth.currentCar) {
      setSelectedCar(cars.find((car) => car._id === auth.currentCar));
    }
  }, [cars, auth.currentCar]);

  return (
    <div className={styles.page_head_wrapper}>
      <div className={styles.page_head_wrapper_inner}>
        {logo && <Logo link={logoLink} />}
        <PageTitle
          title={title}
          subTitle={hideCarChange ? "" : selectedCar && selectedCar.name}
        />
        {!isMobile && !hideCarChange && (
          <CarChangeDropdown
            defaultCar={selectedCar}
            onCarChange={handleCarChange}
            cars={cars}
            disabled={carChangeDisabled}
          />
        )}
        {!hideSetting && (
          <Fragment>
            <IconButton
              icon={<QuestionIcon />}
              isTooltip={true}
              tooltipContent="Help"
              tooltipPosition={["bottom"]}
              tooltipAlign="start"
              tooltipTransform={{ top: 10, left: 0 }}
              onClick={handleOpenTutorialModal}
              customClass={styles.help_icon_btn}
              disabled={tutorialContent ? false : true}
            />
            {tutorialContent && (
              <TutorialModal
                open={openTutorialModal}
                onClose={handleCloseTutorialModal}
                title="Tutorial"
                content={tutorialContent}
              />
            )}
          </Fragment>
        )}
        <ProfileDropdown />
      </div>
    </div>
  );
};

export default PageHead;
